import styled from 'styled-components'

const ComponentStyled = styled.div`
  padding: 120px 0;

  .field-logo {
    margin-bottom: 30px;
  }

  .other-projects {
    font-family: 'Cabin';
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.11em;
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.black};
    margin-bottom: 60px;
    text-align: center;
  }

  .map-title {
    font-family: 'Playfair Display';
    font-weight: 900;
    font-size: 40px;
    line-height: 40px;
    letter-spacing: -0.04em;
    color: ${({ theme }) => theme.colors.black};
    margin-bottom: 30px;

    p {
      color: ${({ theme }) => theme.colors.red};
    }
  }

  video {
    width: 100%;
    max-width: 560px;
    height: auto;
    margin-top: 40px;
  }

  .map-desc {
    font-family: 'Cabin';
    font-weight: 700;
    font-size: 20px;
    line-height: 22px;
    letter-spacing: 0.02em;
    color: ${({ theme }) => theme.colors.black};
    margin-bottom: 30px;
  }

  .map-secondary-desc {
    font-family: 'Cabin';
    font-weight: 400;
    font-size: 16px;
    line-height: 21px;
    letter-spacing: 0.02em;
    color: ${({ theme }) => theme.colors.black};
    margin-bottom: 50px;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.values.xl}px`}) {
    padding: 0;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.values.xl}px`}) {
    padding: 120px 0;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.values.md}px`}) {
    padding-bottom: 32px;
    .field-logo {
      margin-bottom: 30px;
    }
  }
`

export default ComponentStyled
